import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./DialogFooter.styled";
export const DialogFooter = forwardRef(({ children, footerButtons, isCentered, buttonLayout, ...otherProps }, ref) => {
    const endcapProps = buttonLayout === "endcap"
        ? {
            isDistributed: true,
            isJoined: true,
            attachedTo: "bottom"
        }
        : {};
    if (children) {
        return (_jsx(Styled.DialogFooter, { ref: ref, isCentered: isCentered, "data-testid": "DialogFooter", ...otherProps, children: children }));
    }
    return footerButtons ? (_jsx(Styled.DialogFooter, { ref: ref, buttonLayout: buttonLayout, "data-testid": "DialogFooter", ...otherProps, children: _jsx(Styled.DialogFooterButtonGroup, { isCentered: isCentered, ...endcapProps, children: footerButtons.map(({ palette, priority, label, ...buttonProps }, index) => (_jsx(Styled.DialogFooterButton, { priority: priority ? priority : "primary", palette: palette ? palette : "interactiveConstructive", ...buttonProps, children: label && label }, `${index}${label}`))) }) })) : null;
});
DialogFooter.displayName = "DialogFooter";
DialogFooter.defaultProps = {
    isCentered: false
};
